export function formatSQL(sql: string): string {
  const keywords: Record<string, string> = {
    SELECT: "blue",
    FROM: "blue",
    WHERE: "blue",
    "GROUP BY": "blue",
    "ORDER BY": "blue",
    JOIN: "blue",
    "LEFT JOIN": "blue",
    "RIGHT JOIN": "blue",
    "INNER JOIN": "blue",
    AND: "blue",
    OR: "blue",
    AS: "blue",
    ON: "blue",
    IN: "blue",
    NOT: "blue",
    NULL: "blue",
    CASE: "blue",
    WHEN: "blue",
    THEN: "blue",
    ELSE: "blue",
    END: "blue",
  };

  const functions: Record<string, string> = {
    COUNT: "green",
    SUM: "green",
    AVG: "green",
    MAX: "green",
    MIN: "green",
    COALESCE: "green",
    ISNULL: "green",
    NULLIF: "green",
    CAST: "green",
    CONVERT: "green",
    DATEADD: "green",
    DATEDIFF: "green",
  };

  sql = sql.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

  // First, handle multi-word keywords
  const multiWordKeywords = Object.keys(keywords)
    .filter((k) => k.includes(" "))
    .sort((a, b) => b.length - a.length); // Sort by length descending

  let formattedSQL = sql.toUpperCase();

  // Replace multi-word keywords first
  for (const keyword of multiWordKeywords) {
    const regex = new RegExp(`\\b${keyword}\\b`, "g");
    formattedSQL = formattedSQL.replace(
      regex,
      `<span style="color: ${keywords[keyword]}">${keyword}</span>`
    );
  }

  // Then handle single-word keywords and functions
  const words = formattedSQL.split(/(\s+|,|\(|\))/);
  const formattedWords: string[] = [];

  for (const word of words) {
    if (word.match(/<span/)) {
      formattedWords.push(word);
      continue;
    }

    const cleanWord = word.trim().toUpperCase();
    if (keywords[cleanWord]) {
      formattedWords.push(
        `<span style="color: ${keywords[cleanWord]}">${word}</span>`
      );
    } else if (functions[cleanWord]) {
      formattedWords.push(
        `<span style="color: ${functions[cleanWord]}">${word}</span>`
      );
    } else {
      formattedWords.push(word);
    }
  }

  formattedSQL = formattedWords.join("");
  formattedSQL = formattedSQL.replace(
    /\b(SELECT|FROM|WHERE|JOIN|LEFT JOIN|RIGHT JOIN|INNER JOIN|GROUP BY|ORDER BY)\b/g,
    "\n$1"
  );
  formattedSQL = formattedSQL.replace(/\n+/g, "\n");
  return formattedSQL;
}
